import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import * as yup from "yup";
import { newsLetterActions } from "redux/actions/NewsLetter/newsLetterActions";
import { useTranslation } from "react-i18next";

interface newsLetterTypes {
  email: string;
}

const useNewsLetterFormik = () => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();

  const formik = useFormik({
    initialValues: {
      email: "",
    },

    validationSchema: yup.object({
      email: yup
        .string()
        .email()
        .required(`${t("Email is required")}`),
    }),

    onSubmit: async (values: newsLetterTypes) => {
      dispatch(
        newsLetterActions({
          email_address: values.email,
        })
      );
    },
  });

  return formik;
};

export { useNewsLetterFormik };
